<template>
  <div class="card">
    <h3>Financials</h3>
    <div class="table-wrap compact-table-wrapper">
      <table class="compact-table">
        <caption class="sr-only">Financials table showing recent reporting periods</caption>
        <thead>
          <tr>
            <th scope="col" class="left">Account</th>
            <th v-if="bs.periodDates && bs.periodDates[0]" scope="col">{{ formatDate(bs.periodDates[0]) }}</th>
            <th v-if="bs.periodDates && bs.periodDates[1]" scope="col">{{ formatDate(bs.periodDates[1]) }}</th>
          </tr>
        </thead>
        <tbody>
          <tr class="section"><td colspan="3"><b>Balance Sheet</b></td></tr>
          <tr><td class="account">Total Assets</td><td>{{ format(bs.totalAssets[0]) }}</td><td>{{ format(bs.totalAssets[1]) }}</td></tr>
          <tr><td class="account">Current Assets</td><td>{{ format(bs.currentAssets[0]) }}</td><td>{{ format(bs.currentAssets[1]) }}</td></tr>
          <tr><td class="account">Cash & Equivalents</td><td>{{ format(bs.cashEquivalents[0]) }}</td><td>{{ format(bs.cashEquivalents[1]) }}</td></tr>
          <tr><td class="account">Total Liabilities</td><td>{{ format(bs.totalLiabilities[0]) }}</td><td>{{ format(bs.totalLiabilities[1]) }}</td></tr>
          <tr><td class="account">Current Liabilities</td><td>{{ format(bs.currentLiabilities[0]) }}</td><td>{{ format(bs.currentLiabilities[1]) }}</td></tr>
          <tr><td class="account">Total Equity</td><td>{{ format(bs.totalEquities[0]) }}</td><td>{{ format(bs.totalEquities[1]) }}</td></tr>

          <tr class="section"><td colspan="3"><b>Income Statement</b></td></tr>
          <tr><td class="account">Total Revenues</td><td>{{ format(is.totalRevenues[0]) }}</td><td>{{ format(is.totalRevenues[1]) }}</td></tr>
          <tr><td class="account">Cost of Sales</td><td>{{ format(is.costOfSales[0]) }}</td><td>{{ format(is.costOfSales[1]) }}</td></tr>
          <tr><td class="account">Gross Profit</td><td>{{ format(is.grossProfit[0]) }}</td><td>{{ format(is.grossProfit[1]) }}</td></tr>
          <tr><td class="account">Gross Margin</td><td>{{ formatPct(is.grossMargin[0]) }}</td><td>{{ formatPct(is.grossMargin[1]) }}</td></tr>
          <tr><td class="account">Operating Profit</td><td>{{ format(is.totalOperationProfit[0]) }}</td><td>{{ format(is.totalOperationProfit[1]) }}</td></tr>
          <tr><td class="account">EBITDA</td><td>{{ format(is.ebitda[0]) }}</td><td>{{ format(is.ebitda[1]) }}</td></tr>
          <tr><td class="account">EBITDA Margin</td><td>{{ formatPct(is.ebitdaMargin[0]) }}</td><td>{{ formatPct(is.ebitdaMargin[1]) }}</td></tr>
          <tr><td class="account">EBIT</td><td>{{ format(is.ebit[0]) }}</td><td>{{ format(is.ebit[1]) }}</td></tr>
          <tr><td class="account">EBIT Margin</td><td>{{ formatPct(is.ebitMargin[0]) }}</td><td>{{ formatPct(is.ebitMargin[1]) }}</td></tr>
          <tr><td class="account">Net Income</td><td>{{ format(is.netIncome[0]) }}</td><td>{{ format(is.netIncome[1]) }}</td></tr>
          <tr><td class="account">Net Margin</td><td>{{ formatPct(is.netMargin[0]) }}</td><td>{{ formatPct(is.netMargin[1]) }}</td></tr>
          <tr><td class="account">EPS</td><td>{{ format(is.eps[0]) }}</td><td>{{ format(is.eps[1]) }}</td></tr>

          <tr class="section"><td colspan="3"><b>Cash Flow</b></td></tr>
          <tr><td class="account">Operating Cash Flow</td><td>{{ format(cf.cashflowOperating[0]) }}</td><td>{{ format(cf.cashflowOperating[1]) }}</td></tr>
          <tr><td class="account">Investing Cash Flow</td><td>{{ format(cf.cashflowInvesting[0]) }}</td><td>{{ format(cf.cashflowInvesting[1]) }}</td></tr>
          <tr><td class="account">Financing Cash Flow</td><td>{{ format(cf.cashflowFinancing[0]) }}</td><td>{{ format(cf.cashflowFinancing[1]) }}</td></tr>
          <tr><td class="account">Change in Cash</td><td>{{ format(cf.changeInCash[0]) }}</td><td>{{ format(cf.changeInCash[1]) }}</td></tr>
          <tr><td class="account">Capital Expenditure</td><td>{{ format(cf.capitalExpenditure[0]) }}</td><td>{{ format(cf.capitalExpenditure[1]) }}</td></tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Financials',
  props: {
    bs: { type: Object, default: () => ({ totalAssets:[0,0], currentAssets:[0,0], cashEquivalents:[0,0], totalLiabilities:[0,0], currentLiabilities:[0,0], totalEquities:[0,0], periodDates:[null,null] }) },
    is: { type: Object, default: () => ({ totalRevenues:[0,0], costOfSales:[0,0], grossProfit:[0,0], grossMargin:[0,0], totalOperationProfit:[0,0], ebitda:[0,0], ebitdaMargin:[0,0], ebit:[0,0], ebitMargin:[0,0], netIncome:[0,0], netMargin:[0,0], eps:[0,0], periodDates:[null,null] }) },
    cf: { type: Object, default: () => ({ cashflowOperating:[0,0], cashflowInvesting:[0,0], cashflowFinancing:[0,0], changeInCash:[0,0], capitalExpenditure:[0,0], periodDates:[null,null] }) }
  },
  methods: {
    format(v){ return (v || v===0) ? Number(v).toLocaleString() : '-' },
    formatPct(v){ return (v || v===0) ? (Number(v).toFixed(2) + '%') : '-' },
    formatDate(d){ return (d && d.format) ? d.format('DD-MMM-YYYY') : (d||'') }
  }
}
</script>

<style scoped>
.card{ padding: var(--mobile-card-padding); border-bottom: 1px solid var(--compact-table-border); font-size: var(--mobile-font-size) }
.table-wrap{ overflow-x:auto }
table{ width:100%; border-collapse:collapse; min-width:0; table-layout:auto }
th, td{ border:0; padding:var(--compact-table-cell-padding); text-align:right; font-size:var(--compact-table-font-size) }
th.left, td.account{ text-align:left }
.section td{ background:var(--compact-table-section-bg); font-weight:600; text-align:left }
tbody tr{ border-bottom:1px solid var(--compact-table-border) }
tbody tr:nth-child(odd){ background:var(--compact-table-zebra) }
@media (max-width:420px){ th, td{ font-size: calc(var(--compact-table-font-size) - 1px) } }
</style>
